import Icons from "@/src/components/Icons";
import { useOrderStore } from "@/src/store/useOrderStore";
import { addCommas, digitsEnToFa } from "@persian-tools/persian-tools";
import moment from "jalali-moment";
import { useNavigate } from "react-router-dom";
function OrderDetails() {
  const { order, route } = useOrderStore();
  let history = useNavigate();
  const data =
    route == "penalty"
      ? order.penalties
      : route == "order" || route == "archive"
      ? order.foods
      : null;

  if (order && data.length > 0) {
    return (
      <div>
        <h4
          className="title text-xl font-extrabold flex items-center cursor-pointer"
          onClick={() => history("/report/" + route)}
        >
          <Icons name="arrowBack" fill="none" size={40} />
          جزئیات سفارش
        </h4>
        {route == "archive" && (
          <h4 className="title text-lg font-extrabold flex items-center mt-4">
            {order.name}
          </h4>
        )}
        <div className="my-4 bg-white px-3 py-2 w-fit rounded-xl shadow-mmpz text-sm">
          {digitsEnToFa(
            moment(route == "archive" ? order.deliveryDate : order.date).format(
              "jYYYY-jMM-jDD dddd"
            )
          )}
        </div>
        {route == "archive" && (
          <h4 className="my-4 bg-white px-3 py-3 w-fit rounded-xl shadow-mmpz text-sm flex justify-between gap-4">
            <p className="flex items-center gap-1">
              <Icons name="checked" /> مبلغ کل سفارش:{" "}
            </p>
            <p className="font-bold text-gray-300-mmpz flex gap-1 items-center">
              {digitsEnToFa(addCommas(order.sumPrice))}
              <small className="text-xs">تومان</small>
            </p>
          </h4>
        )}
        <div>
          <div className="w-full shadow-mmpz flex items-center px-4 py-3">
            <div className="item w-2/4 text-sm">
              {route == "penalty" ? "نوع خطا" : "نام غذا"}{" "}
            </div>
            <div className="item w-1/4 text-sm text-end">
              {route == "penalty" ? "سفارش" : "قیمت واحد"}
            </div>
            <div className="item w-1/4 text-sm text-end">مبلغ کل</div>
          </div>
          {data.map((item: any) => {
            return (
              <div className="body flex flex-col gap-3">
                <div className="item shadow-mmpz py-4 flex justify-between mt-4 p-2 rounded-xl">
                  {route != "penalty" ? (
                    <div className="item w-2/5 text-sm flex items-center">
                      {item.type == "Entree" ? (
                        <Icons name="food" size={18} className="me-2" />
                      ) : item.type == "Side" ? (
                        <Icons name="sideFood" size={18} className="me-2" />
                      ) : (
                        <Icons name="other" size={18} className="me-2" />
                      )}{" "}
                      {item.name}{" "}
                    </div>
                  ) : (
                    <div className="item w-2/5 text-sm flex items-center">
                      {item.type}
                    </div>
                  )}

                  <div className="item w-1/5 text-xs text-end pe-2 flex items-center justify-end text-gray-300-mmpz">
                    {route == "penalty" ? (
                      item.name
                    ) : (
                      <>
                        {digitsEnToFa(item.count)}
                        <Icons name="cancel" size={14} />{" "}
                      </>
                    )}
                  </div>
                  {route != "penalty" && (
                    <div className="item w-1/5 text-sm flex items-center justify-center">
                      {digitsEnToFa(addCommas(item.price))}
                    </div>
                  )}
                  <div className="item w-1/5 text-sm flex items-center justify-center">
                    {route != "penalty"
                      ? digitsEnToFa(addCommas(item.price * item.count))
                      : digitsEnToFa(addCommas(item.price))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    history("/report/order");
  }
}

export default OrderDetails;
